































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { ColItemData, getEventAnalyze } from '@/api/common/analyze'
import { DDLItem, DefDDLItem } from '@/api/common/select'
import { copyArray, tryToStr, toDefaultInt, tryToInt } from '@/configs/functions'
import PageList from '@/components/pageLayout/list.vue'
import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
const UserModule = namespace('user')
const DataSourceModule = namespace('dataSource')

@Component({
  components: {
    PageList
  }
})
export default class AnalyzeCruise extends Vue {
  @UserModule.Getter('userInfo')
  public curUser!: UserData

  public get cityId(): number {
    if (this.curUser) {
      /*
    1.省文物局 2.省财政局 3.市文物局 4.市财政局 5.区县
    6.评估机构 7.评估专家 8.文保单位 9.巡查人员
    */
      const u = this.curUser
      const userType = u.UserType
      if (userType == 3 || userType == 4) {
        return u.CityId
      }
    }
    return 0
  }

  public cols: ColItemData[] = []
  public list = []
  public cityList: DDLItem[] = []
  public listLoading: boolean = true
  public queryTerm = {
    CityId: this.cityId,
    DateRange: 0,
    StartDate: '',
    EndDate: ''
  }
  public getQueryTerm() {
    const query = this.$route.query
    // 从页面Url中获取参数
    this.queryTerm = {
      CityId: toDefaultInt(query['CityId'], this.cityId),
      DateRange: tryToInt(query['DateRange']),
      StartDate: tryToStr(query['StartDate']),
      EndDate: tryToStr(query['EndDate'])
    }
  }
  public created() {
    this.getQueryTerm()
    this.fetchSource()
  }

  public mounted() {
    this.doSearch()
  }
  // 点击查询按钮时，页码需要重置为1
  public doSearch() {
    this.fetchData()
  }
  @DataSourceModule.Getter('cityList')
  public cityCounty!: any
  // 数据项加载
  public fetchSource() {
    var cityCounty = copyArray(this.cityCounty)
    if (cityCounty) {
      this.cityList = cityCounty
    }
  }
  public buildCols(source: ColItemData[]) {
    let keys: string[] = []
    let parents: ColItemData[] = []
    source.forEach((e: ColItemData, i: number) => {
      if (keys.findIndex(v => v == e.GroupType) == -1) {
        var n = Object.assign({}, e)
        n.Childs = [e]
        parents.push(n)
        keys.push(e.GroupType)
      } else {
        let parent = parents.find(v => v.GroupType == e.GroupType)
        if (parent) {
          parent.Childs.push(e)
        }
      }
    })
    this.cols = parents
  }
  public itemClick(row: any, filed: string) {
    // console.log(row, filed)
    var url = '/CruiseEvent'
    var query = row.Query + '&' + filed.replace('_', '=')
    if (query.substring(0, 1) == '&') {
      query = '?' + query.substring(1)
    }
    // console.log(url + query)
    this.$router.push(url + query).catch((data: any) => {
      console.log(this.$route.path, data)
    })
  }
  public arraySpanMethod(data: { row: any, column: any, rowIndex: number, columnIndex: number }) {
    // if (rowIndex % 2 === 0) {
    //   if (columnIndex === 0) {
    //     return [1, 2];
    //   } else if (columnIndex === 1) {
    //     return [0, 0];
    //   }
    // }
    //第一列 合并行
    if (data.columnIndex == 0) {
      let rowSpan = data.row.RowSpan
      return rowSpan > 1 ? [rowSpan, 1] : [0, 0]
    }
  }
  public summaryMethod(param: any) {
    const { columns, data } = param
    const sums: any = []
    columns.forEach((column: any, index: number) => {
      if (index === 0) {
        sums[index] = '总计'
        return
      }
      //合计的时候 el-table-column上的 prop参数一定要赋值，不然这边获取到的是undefined
      // console.log('column',column.property)
      const values = data.map((item: any) => Number(item[column.property]))
      if (!values.every((value: any) => isNaN(value))) {
        sums[index] = values.reduce((prev: any, curr: any) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)
        // sums[index] += ' 次'
      } else {
        sums[index] = 'N/A'
      }
    })
    return sums
  }
  public fetchData() {
    const qt = this.queryTerm
    this.listLoading = true
    getEventAnalyze(this.queryTerm).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.list = data.source
        this.buildCols(data.cols)
      }
      this.listLoading = false
    })
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
    this.getQueryTerm()
    this.doSearch()
  }
}
